/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as PlatformRouteRouteImport } from "./routes/platform/route"
import { Route as OrganizationRouteRouteImport } from "./routes/organization/route"
import { Route as OperationsRouteRouteImport } from "./routes/operations/route"
import { Route as AppRouteRouteImport } from "./routes/app/route"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as PlatformIndexRouteImport } from "./routes/platform/index"
import { Route as OrganizationIndexRouteImport } from "./routes/organization/index"
import { Route as OperationsIndexRouteImport } from "./routes/operations/index"
import { Route as AppIndexRouteImport } from "./routes/app/index"
import { Route as PlatformWorkspacesRouteImport } from "./routes/platform/workspaces"
import { Route as LtiLaunchRouteImport } from "./routes/lti.launch"
import { Route as LtiErrorRouteImport } from "./routes/lti.error"
import { Route as InviteCodeRouteImport } from "./routes/invite.$code"
import { Route as OperationsToolIndexRouteImport } from "./routes/operations/$tool/index"
import { Route as AppChannelIdIndexRouteImport } from "./routes/app/$channelId/index"
import { Route as AppChannelIdThreadThreadIdRouteImport } from "./routes/app/$channelId/thread/$threadId"

const PlatformRouteRoute = PlatformRouteRouteImport.update({
  id: "/platform",
  path: "/platform",
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationRouteRoute = OrganizationRouteRouteImport.update({
  id: "/organization",
  path: "/organization",
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsRouteRoute = OperationsRouteRouteImport.update({
  id: "/operations",
  path: "/operations",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: "/app",
  path: "/app",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformIndexRoute = PlatformIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PlatformRouteRoute,
} as any)
const OrganizationIndexRoute = OrganizationIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => OrganizationRouteRoute,
} as any)
const OperationsIndexRoute = OperationsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => OperationsRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRouteRoute,
} as any)
const PlatformWorkspacesRoute = PlatformWorkspacesRouteImport.update({
  id: "/workspaces",
  path: "/workspaces",
  getParentRoute: () => PlatformRouteRoute,
} as any)
const LtiLaunchRoute = LtiLaunchRouteImport.update({
  id: "/lti/launch",
  path: "/lti/launch",
  getParentRoute: () => rootRouteImport,
} as any)
const LtiErrorRoute = LtiErrorRouteImport.update({
  id: "/lti/error",
  path: "/lti/error",
  getParentRoute: () => rootRouteImport,
} as any)
const InviteCodeRoute = InviteCodeRouteImport.update({
  id: "/invite/$code",
  path: "/invite/$code",
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsToolIndexRoute = OperationsToolIndexRouteImport.update({
  id: "/$tool/",
  path: "/$tool/",
  getParentRoute: () => OperationsRouteRoute,
} as any)
const AppChannelIdIndexRoute = AppChannelIdIndexRouteImport.update({
  id: "/$channelId/",
  path: "/$channelId/",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppChannelIdThreadThreadIdRoute =
  AppChannelIdThreadThreadIdRouteImport.update({
    id: "/$channelId/thread/$threadId",
    path: "/$channelId/thread/$threadId",
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/app": typeof AppRouteRouteWithChildren
  "/operations": typeof OperationsRouteRouteWithChildren
  "/organization": typeof OrganizationRouteRouteWithChildren
  "/platform": typeof PlatformRouteRouteWithChildren
  "/invite/$code": typeof InviteCodeRoute
  "/lti/error": typeof LtiErrorRoute
  "/lti/launch": typeof LtiLaunchRoute
  "/platform/workspaces": typeof PlatformWorkspacesRoute
  "/app/": typeof AppIndexRoute
  "/operations/": typeof OperationsIndexRoute
  "/organization/": typeof OrganizationIndexRoute
  "/platform/": typeof PlatformIndexRoute
  "/app/$channelId/": typeof AppChannelIdIndexRoute
  "/operations/$tool/": typeof OperationsToolIndexRoute
  "/app/$channelId/thread/$threadId": typeof AppChannelIdThreadThreadIdRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/invite/$code": typeof InviteCodeRoute
  "/lti/error": typeof LtiErrorRoute
  "/lti/launch": typeof LtiLaunchRoute
  "/platform/workspaces": typeof PlatformWorkspacesRoute
  "/app": typeof AppIndexRoute
  "/operations": typeof OperationsIndexRoute
  "/organization": typeof OrganizationIndexRoute
  "/platform": typeof PlatformIndexRoute
  "/app/$channelId": typeof AppChannelIdIndexRoute
  "/operations/$tool": typeof OperationsToolIndexRoute
  "/app/$channelId/thread/$threadId": typeof AppChannelIdThreadThreadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/app": typeof AppRouteRouteWithChildren
  "/operations": typeof OperationsRouteRouteWithChildren
  "/organization": typeof OrganizationRouteRouteWithChildren
  "/platform": typeof PlatformRouteRouteWithChildren
  "/invite/$code": typeof InviteCodeRoute
  "/lti/error": typeof LtiErrorRoute
  "/lti/launch": typeof LtiLaunchRoute
  "/platform/workspaces": typeof PlatformWorkspacesRoute
  "/app/": typeof AppIndexRoute
  "/operations/": typeof OperationsIndexRoute
  "/organization/": typeof OrganizationIndexRoute
  "/platform/": typeof PlatformIndexRoute
  "/app/$channelId/": typeof AppChannelIdIndexRoute
  "/operations/$tool/": typeof OperationsToolIndexRoute
  "/app/$channelId/thread/$threadId": typeof AppChannelIdThreadThreadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/app"
    | "/operations"
    | "/organization"
    | "/platform"
    | "/invite/$code"
    | "/lti/error"
    | "/lti/launch"
    | "/platform/workspaces"
    | "/app/"
    | "/operations/"
    | "/organization/"
    | "/platform/"
    | "/app/$channelId/"
    | "/operations/$tool/"
    | "/app/$channelId/thread/$threadId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/invite/$code"
    | "/lti/error"
    | "/lti/launch"
    | "/platform/workspaces"
    | "/app"
    | "/operations"
    | "/organization"
    | "/platform"
    | "/app/$channelId"
    | "/operations/$tool"
    | "/app/$channelId/thread/$threadId"
  id:
    | "__root__"
    | "/"
    | "/app"
    | "/operations"
    | "/organization"
    | "/platform"
    | "/invite/$code"
    | "/lti/error"
    | "/lti/launch"
    | "/platform/workspaces"
    | "/app/"
    | "/operations/"
    | "/organization/"
    | "/platform/"
    | "/app/$channelId/"
    | "/operations/$tool/"
    | "/app/$channelId/thread/$threadId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  OperationsRouteRoute: typeof OperationsRouteRouteWithChildren
  OrganizationRouteRoute: typeof OrganizationRouteRouteWithChildren
  PlatformRouteRoute: typeof PlatformRouteRouteWithChildren
  InviteCodeRoute: typeof InviteCodeRoute
  LtiErrorRoute: typeof LtiErrorRoute
  LtiLaunchRoute: typeof LtiLaunchRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/platform": {
      id: "/platform"
      path: "/platform"
      fullPath: "/platform"
      preLoaderRoute: typeof PlatformRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/organization": {
      id: "/organization"
      path: "/organization"
      fullPath: "/organization"
      preLoaderRoute: typeof OrganizationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/operations": {
      id: "/operations"
      path: "/operations"
      fullPath: "/operations"
      preLoaderRoute: typeof OperationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app": {
      id: "/app"
      path: "/app"
      fullPath: "/app"
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/platform/": {
      id: "/platform/"
      path: "/"
      fullPath: "/platform/"
      preLoaderRoute: typeof PlatformIndexRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    "/organization/": {
      id: "/organization/"
      path: "/"
      fullPath: "/organization/"
      preLoaderRoute: typeof OrganizationIndexRouteImport
      parentRoute: typeof OrganizationRouteRoute
    }
    "/operations/": {
      id: "/operations/"
      path: "/"
      fullPath: "/operations/"
      preLoaderRoute: typeof OperationsIndexRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    "/app/": {
      id: "/app/"
      path: "/"
      fullPath: "/app/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/platform/workspaces": {
      id: "/platform/workspaces"
      path: "/workspaces"
      fullPath: "/platform/workspaces"
      preLoaderRoute: typeof PlatformWorkspacesRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    "/lti/launch": {
      id: "/lti/launch"
      path: "/lti/launch"
      fullPath: "/lti/launch"
      preLoaderRoute: typeof LtiLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/lti/error": {
      id: "/lti/error"
      path: "/lti/error"
      fullPath: "/lti/error"
      preLoaderRoute: typeof LtiErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/invite/$code": {
      id: "/invite/$code"
      path: "/invite/$code"
      fullPath: "/invite/$code"
      preLoaderRoute: typeof InviteCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/operations/$tool/": {
      id: "/operations/$tool/"
      path: "/$tool"
      fullPath: "/operations/$tool/"
      preLoaderRoute: typeof OperationsToolIndexRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    "/app/$channelId/": {
      id: "/app/$channelId/"
      path: "/$channelId"
      fullPath: "/app/$channelId/"
      preLoaderRoute: typeof AppChannelIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/$channelId/thread/$threadId": {
      id: "/app/$channelId/thread/$threadId"
      path: "/$channelId/thread/$threadId"
      fullPath: "/app/$channelId/thread/$threadId"
      preLoaderRoute: typeof AppChannelIdThreadThreadIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppChannelIdIndexRoute: typeof AppChannelIdIndexRoute
  AppChannelIdThreadThreadIdRoute: typeof AppChannelIdThreadThreadIdRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppChannelIdIndexRoute: AppChannelIdIndexRoute,
  AppChannelIdThreadThreadIdRoute: AppChannelIdThreadThreadIdRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface OperationsRouteRouteChildren {
  OperationsIndexRoute: typeof OperationsIndexRoute
  OperationsToolIndexRoute: typeof OperationsToolIndexRoute
}

const OperationsRouteRouteChildren: OperationsRouteRouteChildren = {
  OperationsIndexRoute: OperationsIndexRoute,
  OperationsToolIndexRoute: OperationsToolIndexRoute,
}

const OperationsRouteRouteWithChildren = OperationsRouteRoute._addFileChildren(
  OperationsRouteRouteChildren,
)

interface OrganizationRouteRouteChildren {
  OrganizationIndexRoute: typeof OrganizationIndexRoute
}

const OrganizationRouteRouteChildren: OrganizationRouteRouteChildren = {
  OrganizationIndexRoute: OrganizationIndexRoute,
}

const OrganizationRouteRouteWithChildren =
  OrganizationRouteRoute._addFileChildren(OrganizationRouteRouteChildren)

interface PlatformRouteRouteChildren {
  PlatformWorkspacesRoute: typeof PlatformWorkspacesRoute
  PlatformIndexRoute: typeof PlatformIndexRoute
}

const PlatformRouteRouteChildren: PlatformRouteRouteChildren = {
  PlatformWorkspacesRoute: PlatformWorkspacesRoute,
  PlatformIndexRoute: PlatformIndexRoute,
}

const PlatformRouteRouteWithChildren = PlatformRouteRoute._addFileChildren(
  PlatformRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  OperationsRouteRoute: OperationsRouteRouteWithChildren,
  OrganizationRouteRoute: OrganizationRouteRouteWithChildren,
  PlatformRouteRoute: PlatformRouteRouteWithChildren,
  InviteCodeRoute: InviteCodeRoute,
  LtiErrorRoute: LtiErrorRoute,
  LtiLaunchRoute: LtiLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
